<template>
    <div>
       <h2> AIdea Solutions Pvt. Ltd. is a Bengaluru based tech start-up. Our ambition is to bring to general investors tools, similar to what ChatGPT and Claude have done for programmers.</h2>
       <h3>Enterprise Customer ? Want to build an AI toolkit like DipSip on your propeitary data ? Talk to us. DipSip is a self-hosted small language model / AI Agent system, where internal data is never posted to external LLMs.</h3>
    </div>
</template>